export const createUniqueKey = (): string => {
  const browserCrypto = (globalThis as unknown as { crypto?: Pick<Crypto, 'randomUUID'> }).crypto;

  if (typeof browserCrypto?.randomUUID === 'function') {
    return browserCrypto.randomUUID();
  }

  return `${Date.now().toString()}-${Math.random().toString(36).slice(2, 9)}`;
};
